import i18n from 'app/i18n/i18n'

export default {
  session: {
    app_person: {
      id: 0
    }
  },
  is_user: false,
  is_anonymous: true,
  user: {
    id: false,
    display_name: i18n.t('Guest'),
    roles: {
      is_admin: false,
      is_moderator: false,
      is_finance_admin: false
    }
  },
  self: {
    id: false,
    display_name: i18n.t('Guest'),
    roles: {
      is_admin: false,
      is_moderator: false,
      is_finance_admin: false
    }
  },
  sport_vokrug_plus_subscription: null,
  sport_vokrug_plus_subscription_status: null,
  has_sport_vokrug_plus_subscription: false,
  sport_vokrug_plus_subscription_loading: false,
  sport_vokrug_plus_subscription_error: null,
  isInitialized: false,
  ui: {
    isMobileMenuOpen: false
  }
}
